"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../../api/webAApi");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var moment = require("moment");
var BrandGwsGameProviderListCtl = /** @class */ (function (_super) {
    __extends(BrandGwsGameProviderListCtl, _super);
    function BrandGwsGameProviderListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_gws_gameprovider_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_id; });
        _this.dk_gws_gameprovider_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.gws_gameprovider_title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BrandGwsGameProviderListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    BrandGwsGameProviderListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    BrandGwsGameProviderListCtl.prototype.LoadData = function (brandId, onDone) {
        var _this = this;
        webAApi_1.ListBrandGwsGameProviderByBrandIdGet.exec({ brand_id: brandId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    gws_gameprovider_id: resp.list[i].gws_gameprovider_id,
                    gws_gameprovider_title: resp.list[i].gws_gameprovider_title,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BrandGwsGameProviderListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBrandGwsGameProvider.exec({
            data: {
                brand_id: data.brand_id,
                app_currency_id: data.app_currency_id,
                gws_gameprovider_id: data.gws_gameprovider_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                brand_id: data.brand_id,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.currency_title,
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                date_changed2: moment(resp.date_added_uts_ms).utc(false),
                gws_gameprovider_id: data.gws_gameprovider_id,
                gws_gameprovider_title: resp.gws_gameprovider_title,
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    /*public EditData(data: IEditBrandGwsGameProvider, onDone?: () => void) {
        let _tmp = this.getById(data.key);
        if (_tmp) {

            DoEditBrandGwsGameProvider.exec({

                data: {
                    brands_gws_gameprovider_id: data.key,
                    app_currency_id: data.app_currency_id,
                    gws_gameprovider_id: data.gws_gameprovider_id
                }
                
            }, (resp) => {

                _tmp.gws_gameprovider_id = data.gws_gameprovider_id;
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.gws_gameprovider_title = resp.gws_gameprovider_title;
                _tmp.app_currency_title = resp.app_currency_title;

                this.Update();
                if (onDone) {
                    onDone();
                }

            }, (err) => {
                this._errDialog.ShowApiError(err);
            });
        }
    }*/
    BrandGwsGameProviderListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BrandGwsGameProviderListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBrandGwsGameProvider.exec({
                data: {
                    brands_gws_gameprovider_id: key,
                }
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BrandGwsGameProviderListCtl;
}(BaseController_1.BaseController));
exports.BrandGwsGameProviderListCtl = BrandGwsGameProviderListCtl;
/*export interface IEditBrandGwsGameProvider {

    key : number;

    gws_gameprovider_id : number;
    app_currency_id : number;

}*/ 



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ctl/gateways/BrandGwsGameProviderListCtl.ts
// module id = 921
// module chunks = 0